// extracted by mini-css-extract-plugin
export default {"cardinformationitem":"CardInformationItem_cardinformationitem__1TglW","cardinformationitem--contrast":"CardInformationItem_cardinformationitem--contrast__4yFfu"};